<template>
  <v-card>
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Configuración</div>
      <div>
        <v-btn
          color="warning"
          outlined
          @click="cancel"
          class="mx-2"
          v-show="editing"
        >
          Cancelar
        </v-btn>
        <v-btn
          v-show="!editing"
          color="success"
          outlined
          @click="edit"
          class="mx-2"
        >
          Editar
        </v-btn>
        <v-btn
          v-show="editing"
          color="success"
          outlined
          @click="save"
          clss="mx-2"
        >
          Guardar
        </v-btn>
      </div>
    </v-card>
    <v-card-text>
      <div class="d-flex align-center">
        <v-text-field
          disabled
          v-model="defaultTerritory"
          label="Territorio por Defecto"
        >
          <v-icon
            slot="append-outer"
            :class="editing ? 'enabled-icon' : 'disabled-icon'"
            v-show="editing"
            @click="territoryClick"
          >
            {{ !defaultTerritory ? "mdi-magnify" : "mdi-trash-can-outline" }}
          </v-icon>
        </v-text-field>
      </div>
      <div class="d-flex align-center">
        <v-text-field
          disabled
          v-model="defaultCropDescription"
          label="Cultivo por Defecto"
        >
          <v-icon
            slot="append-outer"
            :class="editing ? 'enabled-icon' : 'disabled-icon'"
            v-show="editing"
            @click="cropClick"
          >
            {{
              !defaultCropDescription ? "mdi-magnify" : "mdi-trash-can-outline"
            }}
          </v-icon>
        </v-text-field>
      </div>
      <div class="d-flex align-center">
        <v-text-field
          disabled
          v-model="defaultCampaignDescription"
          label="Campaña por Defecto"
        >
          <v-icon
            slot="append-outer"
            :class="editing ? 'enabled-icon' : 'disabled-icon'"
            v-show="editing"
            @click="campaignClick"
          >
            {{
              !defaultCampaignDescription
                ? "mdi-magnify"
                : "mdi-trash-can-outline"
            }}
          </v-icon>
        </v-text-field>
      </div>
      <v-switch
        v-model="disableIntellySearch"
        :disabled="!editing"
        inset
        label="Desactivar búsqueda instantánea"
      ></v-switch>
    </v-card-text>
    <!-- component for magnify searchs -->
    <paginated-search-dialog
      v-if="showCrop || showTerritory || showCampaign"
      :show="showCrop || showTerritory || showCampaign"
      :title="searchOptions.title"
      :endpoint="searchOptions.endpoint"
      :ordering="searchOptions.ordering"
      :searchLabel="searchOptions.searchLabel"
      :headers="searchOptions.headers"
      :filterString="searchOptions.filterString"
      :canEdit="false"
      :canAdd="false"
      @itemSelected="searchSelected($event)"
      @cancel="searchCanceled"
    >
    </paginated-search-dialog>
  </v-card>
</template>
<script>
import PaginatedSearchDialog from "@/components/PaginatedSearchDialog.vue";

export default {
  name: "Setting",

  components: {
    PaginatedSearchDialog
  },

  data: () => ({
    editing: false,
    crops: null,
    campaigns: null,
    defaultCropDescription: null,
    defaultCropId: null,
    defaultCampaignDescription: null,
    defaultCampaignId: null,
    defaultTerritory: null,
    disableIntellySearch: false,
    showCrop: false,
    showTerritory: false,
    showCampaign: false,
    searchOptions: null
  }),

  methods: {
    cropClick() {
      if (this.defaultCropId) {
        this.defaultCropId = null;
        this.defaultCropDescription = null;
      } else {
        //add Crop
        this.searchOptions = {
          headers: [{ text: "Cultivo", value: "description", sortable: false }],
          title: "Cultivos",
          endpoint: "/data/crops",
          ordering: "description",
          searchLabel: "Cultivo",
          filterstring: null
        };
        this.showCrop = true;
      }
    },

    campaignClick() {
      if (this.defaultCampaignId) {
        this.defaultCampaignId = null;
        this.defaultCampaignDescription = null;
      } else {
        //add Campaign
        this.searchOptions = {
          headers: [{ text: "Campaña", value: "description", sortable: false }],
          title: "Campañas",
          endpoint: "/data/campaigns",
          ordering: "-code",
          searchLabel: "Campaña",
          filterstring: null
        };
        this.showCampaign = true;
      }
    },

    territoryClick() {
      if (this.defaultTerritory) {
        this.defaultTerritory = null;
      } else {
        //add territory
        this.searchOptions = {
          headers: [
            { text: "Territorio", value: "description", sortable: false },
            { text: "Tipo", value: "description_type", sortable: false }
          ],
          title: "Territorio",
          endpoint: "/data/territories_hierarchy",
          ordering: "level,description",
          searchLabel: "Localidad,Departamento,Provincia",
          filterstring: "level__gte=1&level__lte=2"
        };
        this.showTerritory = true;
      }
    },

    searchSelected(data) {
      if (this.showTerritory) {
        this.territorySelected(data);
      } else if (this.showCrop) {
        this.cropSelected(data);
      } else if (this.showCampaign) {
        this.campaignSelected(data);
      }
    },

    territorySelected(data) {
      this.showTerritory = false;
      this.searchOptions = {};
      // eslint-disable-next-line
      this.defaultTerritory = (data.level===1 ? "     ," : "" ) + data.description;
    },

    cropSelected(data) {
      this.showCrop = false;
      this.searchOptions = {};
      this.defaultCropId = data.id;
      this.defaultCropDescription = data.description;
    },

    campaignSelected(data) {
      this.showCampaign = false;
      this.searchOptions = {};
      this.defaultCampaignId = data.id;
      this.defaultCampaignDescription = data.code;
    },

    searchCanceled() {
      this.showCrop = false;
      this.showTerritory = false;
      this.showCampaign = false;
      this.searchOptions = {};
    },

    async cancel() {
      // eslint-disable-next-line
      if(await this.$confirm("Confirme que desea abandonar la edición, los datos modificados se perderán")) {
        this.editing = false;
        this.loadValues();
      }
    },

    edit() {
      this.editing = true;
    },

    async save() {
      try {
        let object = {};
        let value = null;
        let index = -1;
        const editableParameters = new Set([
          "defaultCropId",
          "defaultCampaignId",
          "defaultTerritory",
          "disableIntellySearch"
        ]);
        let user_configurations = await this.$bRoot.search(
          "/user/user_configurations"
        );
        const userConfigurations = Array.isArray(user_configurations.data)
          ? user_configurations.data
          : user_configurations.data.results || [];

        for (const parameter of this.configuration_parameters) {
          if (!editableParameters.has(parameter.name)) {
            continue;
          }

          if (this[parameter.name]) {
            value = this[parameter.name].toString();
          } else if (parameter.name === "disableIntellySearch") {
            value = "false";
          } else {
            value = "";
          }

          index = userConfigurations.findIndex(
            item => item.name === parameter.name
          );
          if (index !== -1) {
            if (value === "") {
              await this.$bRoot.axios.delete(userConfigurations[index].url);
            } else {
              object = { ...userConfigurations[index] };
              object.value = value;
              await this.$bRoot.save(object);
            }
          } else if (value !== "") {
            object = {
              value: value.toString(),
              parameter: parameter.url
            };
            await this.$bRoot.add("/user/user_configurations", null, object);
          }
        }
      } catch (error) {
        if (!this.$bRoot.Errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.editing = false;
        let appInfo = await this.$bRoot.search(
          "user/applicationinfo/" + this.$bRoot.appName
        );
        this.$bRoot.appInfo = appInfo.data;
        this.loadValues();
      }
    },

    loadValues() {
      //crop
      this.defaultCropId = this.$bRoot.getUserParam("defaultCropId");
      let index = this.crops.findIndex(item => item.id == this.defaultCropId);
      if (index !== -1) {
        this.defaultCropDescription = this.crops[index].description;
      } else {
        this.defaultCropDescription = null;
      }
      //campaign
      this.defaultCampaignId = this.$bRoot.getUserParam("defaultCampaignId");
      index = this.campaigns.findIndex(
        item => item.id == this.defaultCampaignId
      );
      if (index !== -1) {
        this.defaultCampaignDescription = this.campaigns[index].code;
      } else {
        this.defaultCampaignDescription = null;
      }
      //territori
      this.defaultTerritory = this.$bRoot.getUserParam("defaultTerritory");
      this.disableIntellySearch = this.$bRoot.getUserParam(
        "disableIntellySearch"
      );
    }
  },

  async mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    //load crops
    let response = await this.$bRoot.search("/data/crops");
    this.crops = response.data.results;

    //load campaigns
    response = await this.$bRoot.search("/data/campaigns", null, "-code");
    this.campaigns = response.data.results;

    //load user parameters
    response = await this.$bRoot.search("/user/configuration_parameters");
    this.configuration_parameters = response.data;
    this.loadValues();
  }
};
</script>
<style scoped>
.enabled-icon {
  pointer-events: auto;
  color: black;
}
.disbled-icon {
  pointer-events: none;
}
</style>
